import HttpService from "./http.service";

const qs = (filtros = {}) =>
  new URLSearchParams(
    Object.entries(filtros).filter(
      ([, v]) => v !== "" && v !== null && v !== undefined
    )
  ).toString();

class LogsService {
  // admin: { area, action, user, registro, busca, dataInicio, dataFim, page, limit }
  listar = async (filtros) => await HttpService.get(`/logs?${qs(filtros)}`);

  areas = async () => await HttpService.get("/logs/areas");

  // histórico de um registro (ex.: area "payables", id da conta)
  historico = async (area, id) =>
    await HttpService.get(`/logs/historico/${area}/${id}`);
}

export default new LogsService();
